import { FlexCenterBoth } from 'components/primitives/flex';
import { Text } from 'components/primitives/typography';
import styled, { css } from 'styled-components';
import { useEffect } from 'react';
import useRudderStackTrack from 'hooks/useRudderStackTrack';
import useIsMount from 'utils/useIsMount';
import { Box } from 'components/primitives/box';

const CheckIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M13.3334 4L6.00008 11.3333L2.66675 8"
      stroke="#0751C2"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default function AtomRadioButton({ label, selected, setOptions }) {
  const rudderTrack = useRudderStackTrack();
  const isMount = useIsMount();
  useEffect(() => {
    if (!isMount) {
      rudderTrack('checkbox_toggle_search', {
        value: selected,
        label,
      });
    }
  }, [selected]);

  const handleClick = () => {
    let isSelected = false;
    setOptions((prev) =>
      prev.map((option) => {
        if (option.label === label) {
          isSelected = !option.selected;
          return { ...option, selected: !selected };
        }
        return { ...option, selected: false };
      })
    );
    rudderTrack('checkbox_toggle_search', {
      value: isSelected,
      label,
    });
  };

  return (
    <CheckButton checked={selected} onClick={handleClick}>
      <Text fSize="14px" fWeight="500">
        {label}
      </Text>
      <IconWrapper style={{ visibility: selected ? 'visible' : 'hidden' }}>
        <CheckIcon />
      </IconWrapper>
    </CheckButton>
  );
}

const CheckButton = styled(FlexCenterBoth)<{ checked: boolean }>`
  border: 1px solid #eef1f5;
  border-radius: 8px;
  cursor: pointer;
  padding: 12px 24px 12px 40px;
  text-align: center;
  min-width: 50px;
  white-space: nowrap;

  &:hover {
    background-color: #f8f9fa;
    border-color: #eef1f5;
  }

  ${({ checked }) =>
    checked &&
    css`
      background: #e9f1fc;
      border-color: #e9f1fc;
      color: #0751c2;

      &:hover {
        background: #e9f1fc;
        border-color: #e9f1fc;
        color: #0751c2;
      }
    `};
`;

const IconWrapper = styled(Box)`
  padding-left: 8px;
  display: flex;
`;
